import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahReferenceData } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { SahReferenceDataSync } from '~support-at-home/models/sahReferenceData';

// Covers the global Services Australia reference data sync status (GET /v2/sah/reference-data).
// Distinct from prodaConnection.ts, which manages the PRODA device connection itself rather than
// the reference lists fetched through it.
//
// READ ONLY, deliberately. Both refresh mutations that used to live here are gone: the per-list one
// lost its caller when the per-row Actions column went in TAV-2589, and Refresh All lost its caller
// when the button went in TAV-3233. Refreshing is the scheduled lambda's job now, so there is no
// caller to write. The server routes still exist (api/src/routes/sah_reference_data.mjs); this file
// simply no longer binds a hook to them. See TAV-3076 for the lambda's deployment prerequisites.
export const sahReferenceDataApi = createApi({
  reducerPath: 'sahReferenceDataApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahReferenceData }),
  tagTypes: ['sahReferenceData'],
  endpoints: (builder) => ({
    getSahReferenceData: builder.query<SahReferenceDataSync[], void>({
      query: () => ({ url: '', method: 'GET' }),
      transformResponse: (payload) => unwrap<SahReferenceDataSync[]>(payload),
      providesTags: [{ type: 'sahReferenceData', id: 'LIST' }],
    }),
  }),
});

export const { useGetSahReferenceDataQuery } = sahReferenceDataApi;
